import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import { heatTrend } from "@/mocks/trendData";

const stats = [
  { label: "网红阵营热度指数", value: "83", delta: "+6", up: true },
  { label: "明星阵营热度指数", value: "75", delta: "-3", up: false },
  { label: "两阵营热度差", value: "8", delta: "收窄", up: true },
];

export default function TrendSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="TREND"
          title="热度走势：流量在往哪边流"
          description="两条曲线记录最近七个月两阵营的关注度变化。我们不追求精确到小数点，只想让你看到方向。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 lg:col-span-2">
            <div className="mb-4 flex flex-wrap items-center gap-5 text-xs text-foreground-600">
              <span className="inline-flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full bg-primary-500" />
                网红阵营
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full bg-secondary-500" />
                明星阵营
              </span>
            </div>
            <div className="h-64 w-full md:h-72">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={heatTrend} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
                  <defs>
                    <linearGradient id="creatorFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="oklch(var(--primary-500))" stopOpacity={0.35} />
                      <stop offset="100%" stopColor="oklch(var(--primary-500))" stopOpacity={0.02} />
                    </linearGradient>
                    <linearGradient id="starFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="oklch(var(--secondary-500))" stopOpacity={0.3} />
                      <stop offset="100%" stopColor="oklch(var(--secondary-500))" stopOpacity={0.02} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="4 4" stroke="oklch(var(--background-300))" vertical={false} />
                  <XAxis
                    dataKey="month"
                    tick={{ fontSize: 12, fill: "oklch(var(--foreground-500))" }}
                    axisLine={false}
                    tickLine={false}
                  />
                  <YAxis
                    domain={[40, 100]}
                    tick={{ fontSize: 12, fill: "oklch(var(--foreground-500))" }}
                    axisLine={false}
                    tickLine={false}
                  />
                  <Tooltip
                    contentStyle={{
                      borderRadius: 8,
                      border: "1px solid oklch(var(--background-300))",
                      background: "oklch(var(--background-50))",
                      fontSize: 12,
                      fontFamily: "var(--font-body)",
                    }}
                    labelStyle={{ color: "oklch(var(--foreground-800))" }}
                  />
                  <Area
                    type="monotone"
                    dataKey="creator"
                    name="网红阵营"
                    stroke="oklch(var(--primary-500))"
                    strokeWidth={2.5}
                    fill="url(#creatorFill)"
                  />
                  <Area
                    type="monotone"
                    dataKey="star"
                    name="明星阵营"
                    stroke="oklch(var(--secondary-500))"
                    strokeWidth={2.5}
                    fill="url(#starFill)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-1 flex-col justify-center rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <p className="text-xs text-foreground-500">{stat.label}</p>
                <div className="mt-2 flex items-end gap-3">
                  <span className="font-heading text-3xl font-bold text-foreground-950">{stat.value}</span>
                  <span
                    className={`mb-1 inline-flex items-center gap-1 text-xs font-medium ${
                      stat.up ? "text-primary-600" : "text-secondary-600"
                    }`}
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className={stat.up ? "ri-arrow-up-line text-sm" : "ri-arrow-down-line text-sm"} />
                    </span>
                    {stat.delta}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}